import { MonoTypeOperatorFunction } from 'rxjs';
import { auditTime, retryWhen, scan } from 'rxjs/operators';

export const DEFAULT_RETRY_DELAY_MS = 5 * 1000;

export function retryWithDelay<T>(
    delayMs = DEFAULT_RETRY_DELAY_MS,
    maxRetries = Infinity
): MonoTypeOperatorFunction<T> {
    return retryWhen((error) => {
        return error.pipe(
            scan((count) => {
                if (count >= maxRetries) throw new Error(`Max retries (${maxRetries}) exceeded`);
                return count + 1;
            }, 0),
            auditTime(delayMs)
        );
    });
}
